/** @module csi/widget/DateRangeMenu **/
define([
	"dojo/_base/declare",
	"dijit/Menu"
], function(declare,Menu) {

	return declare(Menu, {
		/**
		 * Prevent clearing selected item on blur
		 * @param {boolean} clearSelectedItem
		 */
		_cleanUp: function(clearSelectedItem) {
			this.inherited(arguments, [false]);
		}
	});
});